module.exports = __webpack_public_path__ + "static/media/logo-bestpark-blue.022a9eca.svg";